// Google Business Profile reviews, collected 24 October 2026.
// Reviewer text is verbatim and must not be edited.

export interface GoogleReview {
  name: string
  rating: number
  date: string
  tag: 'Coaching' | 'DNA Coaching' | 'Book'
  pullQuote: string
  text: string
}

export const googleRating = 5.0
export const googleReviewCount = 5

/** Public reviews page for the Google Business Profile. */
export const googleReviewsUrl =
  'https://www.google.com/search?q=BioHackMe+Camilla+Thompson#lrd=0x0:0x0,1'

export const googleReviews: GoogleReview[] = [
  {
    name: 'Steph W.',
    rating: 5,
    date: '2026-08',
    tag: 'Coaching',
    pullQuote: 'An absolute powerhouse of knowledge in the biohacking and wellness space.',
    text: `Camilla Thompson is an absolute powerhouse of knowledge in the biohacking and wellness space. Her experience, expertise and genuine passion for helping people optimise their health and longevity, are second to none.

What I love most about Cam is her approach - she's incredibly knowledgeable without ever being forceful or judgemental. Her coaching is practical, empowering and completely personalised, making you feel supported rather than overwhelmed.

Her book 'Biohackme' is an absolute must-have for anyone serious about taking control of their health, wellbeing and longevity. I couldn't recommend Camilla highly enough.`,
  },
  {
    name: 'Rebecca G.',
    rating: 5,
    date: '2026-08',
    tag: 'DNA Coaching',
    pullQuote: 'A first, easy step towards a deeper understanding of how your body works.',
    text: `I've recently completed the DNA coaching package with Camilla and it was an incredibly informative session, that provides data on a huge range of functions including hormones, cardiovascular function, metabolism, sleep, brain and methylation - there is so much information it would have been overwhelming without Camilla interpreting the results and explaining what it means.

Next step now is blood tests then adapting food and supplements to ensure my body is most supported.

I highly recommend for anyone serious about their health - this is a first, easy step towards a deeper understanding of how your body works.`,
  },
  {
    name: 'Nicola C.',
    rating: 5,
    date: '2026-04',
    tag: 'Book',
    pullQuote: 'Nothing feels overwhelming or extreme, just thoughtful, doable changes.',
    text: `I absolutely loved Biohack Me - it's one of those rare reads that meets you exactly where you are on your health journey. Whether you're completely new to the world of biohacking or already deep into your wellness practices, this book makes everything feel accessible, practical, and empowering.

What I found especially refreshing is how it highlights that many of us are already "biohacking" in our everyday lives - we just might not have called it that yet! For me, it was incredibly validating to realise I'm already doing some things right, while also picking up simple, realistic tips and tweaks that I can easily bring into my daily routine. Nothing feels overwhelming or extreme - just thoughtful, doable changes that genuinely support better choices and a more energised life.

A brilliant, encouraging read that leaves you feeling capable, informed, and inspired. Highly recommend.`,
  },
  {
    name: 'Louise W.',
    rating: 5,
    date: '2026-02',
    tag: 'Book',
    pullQuote: 'An incredible introduction to biohacking.',
    text: `Highly recommend, amazing read! This book has been an incredible introduction to bio-hacking for me. I love the way it's written and the ease of absorbing the different chapters. Camilla writes in such a relatable way, making the bio hacking concepts really easy to understand plus weaving in her personal story which I love.`,
  },
  {
    name: 'Linda H.',
    rating: 5,
    date: '2026-01',
    tag: 'Book',
    pullQuote: 'Inspiring rather than overwhelming.',
    text: `An incredible read. So much fantastic information but also comprehensive which is inspiring rather than overwhelming. Thank you Camilla you have motivated me on my journey of positive aging.`,
  },
]
